import Vue from 'vue'

import { Services } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import button from '@/components/button'

export default function(h) {
  if (this.id) {
    return h(
      button,
      {
        props: {
          icon: icons.edit,
          mode: buttonModes.flat
        },
        on: {
          click: () => {
            Vue.router.push({
              name: `${Services.eventsHistory}.single`,
              params: { id: this.id }
            })
          }
        }
      }
    )
  }
}
